export default __webpack_public_path__ + "8727365be90eeb90314f0e96283fc310.wav";